import React, { InputHTMLAttributes, useId } from 'react'

import * as SC from './styled'

export type FormFieldInputProps = InputHTMLAttributes<HTMLInputElement> & {
  name?: string
  className?: string
  error?: string
}

const FormFieldHidden = React.forwardRef<any, FormFieldInputProps>(
  function FormFieldHidden({ ...props }, ref) {
    const localId = useId()
    return <SC.Input id={localId} type="hidden" {...props} ref={ref} />
  }
)
export default FormFieldHidden
